import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// This file is copy from AppLogo.tsx and is used to render a smaller app logo.

import AppIcon from '@atlaskit/icon/core/app';
import React, { useState } from 'react';
import { AddOnIconCoverSmall, AppLogoStyleSmall } from './AppTile.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export function AppLogoSmall(props) {
  const [imgLoadError, setImgLoadError] = useState(false);
  function onError() {
    setImgLoadError(true);
  }
  if (imgLoadError) {
    return /*#__PURE__*/_jsx(AddOnIconCoverSmall, {
      children: /*#__PURE__*/_jsx(AppIcon, {
        label: ""
      })
    });
  }
  return /*#__PURE__*/_jsx(AppLogoStyleSmall, _objectSpread(_objectSpread({}, props), {}, {
    onError: onError
  }));
}